// extracted by mini-css-extract-plugin
export default {"form":"PersonelForm_form__b8cqf","checkbox-group":"PersonelForm_checkbox-group__K04gx"};